export default __webpack_public_path__ + "static/media/USUARIO_FINAL_BANNER_IMG.5e4cd9db.png";